/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Curated_Theme_PresetsInputs */

const en_curated_theme_presets = /** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Curated Theme Presets`)
};

const id_curated_theme_presets = /** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preset Tema Pilihan`)
};

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const es_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const fr_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const de_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const ja_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const zh_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const ar_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const it_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const ru_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const pt_curated_theme_presets = en_curated_theme_presets;

/** @type {(inputs: Curated_Theme_PresetsInputs) => LocalizedString} */
const ko_curated_theme_presets = en_curated_theme_presets;

/**
* | output |
* | --- |
* | "Curated Theme Presets" |
*
* @param {Curated_Theme_PresetsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const curated_theme_presets = /** @type {((inputs?: Curated_Theme_PresetsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Curated_Theme_PresetsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_curated_theme_presets(inputs)
	if (locale === "es") return es_curated_theme_presets(inputs)
	if (locale === "fr") return fr_curated_theme_presets(inputs)
	if (locale === "de") return de_curated_theme_presets(inputs)
	if (locale === "ja") return ja_curated_theme_presets(inputs)
	if (locale === "zh") return zh_curated_theme_presets(inputs)
	if (locale === "ar") return ar_curated_theme_presets(inputs)
	if (locale === "id") return id_curated_theme_presets(inputs)
	if (locale === "it") return it_curated_theme_presets(inputs)
	if (locale === "ru") return ru_curated_theme_presets(inputs)
	if (locale === "pt") return pt_curated_theme_presets(inputs)
	return ko_curated_theme_presets(inputs)
});